var React = require('react');

function ProductsIcon33Inline (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Obszar_roboczy_49","data-name":"Obszar roboczy 49","transform":"translate(-6.3 -6.23)"},[React.createElement("path",{"id":"Path_375","data-name":"Path 375","d":"M6.3,6.23V24.85h.01l-.01.01,9.52,9.79H20L9.45,23.8V9.38h21.1V23.8L20,34.65h4.18l9.52-9.79-.01-.01h.01V6.23Z","key":0}),React.createElement("path",{"id":"Path_376","data-name":"Path 376","d":"M11.77,16.99l3.64,8.16h3.18l-3.64-8.16Z","key":1}),React.createElement("path",{"id":"Path_377","data-name":"Path 377","d":"M25.14,11.87,18.59,25.15h3.1l6.54-13.28Z","key":2})]));
}

ProductsIcon33Inline.defaultProps = {"width":"27.4","height":"28.42","viewBox":"0 0 27.4 28.42"};

module.exports = ProductsIcon33Inline;

ProductsIcon33Inline.default = ProductsIcon33Inline;
